import { Component } from '@angular/core'
import { AFFILIATE_DEFAULTS } from '@parkupp/core'

/**
 * Admin handover guide for the affiliate programme (Transparency → Affiliate Programme Guide).
 * Aligned to the client's Fee Share Agreement. Figures come from AFFILIATE_DEFAULTS so the page stays
 * true when defaults change. Keep in step with .brain/affiliates.md, affiliates.service.ts and the
 * "Affiliate Programme" sections of the Transparency report.
 */
@Component({
    selector: 'app-admin-affiliate-guide',
    templateUrl: './admin-affiliate-guide.component.html',
    styleUrls: ['./admin-affiliate-guide.component.scss'],
})
export class AdminAffiliateGuideComponent {
    d = AFFILIATE_DEFAULTS

    sections = [
        { id: 'overview', title: 'Overview' },
        { id: 'numbers', title: 'Key numbers' },
        { id: 'adding', title: 'Adding an affiliate' },
        { id: 'tracking', title: 'Parker introductions' },
        { id: 'landlords', title: 'Building introductions' },
        { id: 'guards', title: 'Security guards' },
        { id: 'commission', title: 'How the fee share is worked out' },
        { id: 'priority', title: 'Building vs parker: who gets paid' },
        { id: 'lifecycle', title: 'Monthly statements' },
        { id: 'payouts', title: 'Paying affiliates' },
        { id: 'rules', title: 'Do’s and don’ts' },
        { id: 'where', title: 'Where to find things' },
        { id: 'pending', title: 'Assumptions to confirm' },
    ]

    /** The agreement's worked example: R1,000/month bay excl. VAT (R1,150 invoice), ParkUpp fee 15%. */
    example = (() => {
        const rental = 1000
        const invoice = rental * (1 + this.d.vatPct / 100)
        const fee = (rental * this.d.defaultPlatformCommissionPct) / 100
        const banking = (rental * this.d.bankingFeePct) / 100
        const tradingIncome = fee - banking
        return {
            invoice,
            rental,
            fee,
            banking,
            tradingIncome,
            parker: (tradingIncome * this.d.parkerCommissionPct) / 100,
            building: (tradingIncome * this.d.landlordCommissionPct) / 100,
        }
    })()

    scrollTo(id: string) {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
}
